import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { GButtonBox, GPopupTitle } from 'components/layouts/GLayoutBox';
import { DialogTitleItem } from 'components/layouts/GModalPopup';
import { GButton } from 'components/atom/button';
import ModalLayout from 'components/layouts/ModalLayout';
import styled from '@emotion/styled';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import HelpDeskContent from 'components/vars/login/HelpDeskContent';

type HelpDeskModalProps = {
  open: boolean;
  close: () => void;
  save: () => void;
};

const HelpDeskModal = (props: HelpDeskModalProps) => {
  const handleClose = () => {
    props.close();
  };

  return (
    <>
      <ModalLayout open={props.open} onClose={handleClose} mMinWidth={800} mMaxWidth={800}>
        <DialogTitleItem onClose={handleClose}>
          <GPopupTitle title2={t('com.label.helpdesk', 'Help Desk')} />
        </DialogTitleItem>
        <DialogContent className="popupContent">
          <AreaAlignWrap>
            <HelpDeskContent />
          </AreaAlignWrap>
        </DialogContent>
        <DialogActions className="popupBottom">
          <GButtonBox>
            {/* <GButton
              txt={t('com.label.00036', '취소')}
              sizes="medium"
              onClick={handleClose}
              btnColor="normal"
              btnstyled="outline"
              hasImg={false}
              hasTxt={true}
            /> */}
          </GButtonBox>
        </DialogActions>
      </ModalLayout>
    </>
  );
};

const AreaAlignWrap = styled.div`
  width: 100%;
  display: flex;
  gap: 24px;
`;

export default HelpDeskModal;
